import { SelectInputV2, SelectInputV2Props } from '@frontend/basic-forms';
import { IoTStateName } from '@frontend/iot/types';
import React from 'react';

import useIoTStateSelect from './iot-state-select.controller';

const ID = 'iot-state-select';
export interface IoTStateSelectProps extends Omit<SelectInputV2Props<IoTStateName>, 'options'> {
    subset?: string[];
}

export const IoTStateSelect = (props: IoTStateSelectProps) => {
    const viewProps = useIoTStateSelect(props);
    return (
        <SelectInputV2<IoTStateName>
            {...props}
            id={ID + props.id}
            label={props.label || 'IoT state'}
            options={viewProps.options}
        />
    );
};
